'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Immutable = require('Immutable');

var _utils = require('react-utils/utils');

var _typeHelpers = require('event-tracking-tools/utils/typeHelpers');

var _getConversionRecord = require('event-tracking-tools/utils/getConversionRecord');

var _getConversionRecord2 = _interopRequireDefault(_getConversionRecord);

var _getIsInstanceOfRecords = require('event-tracking-tools/utils/getIsInstanceOfRecords');

var _getIsInstanceOfRecords2 = _interopRequireDefault(_getIsInstanceOfRecords);

var _getRecordsAsList = require('event-tracking-tools/utils/getRecordsAsList');

var _getRecordsAsList2 = _interopRequireDefault(_getRecordsAsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function enforceAndConvertToMap(eventsSchema) {
  var isMap = _Immutable.Map.isMap(eventsSchema);
  var isRecord = eventsSchema instanceof _Immutable.Record;
  var isPlainObject = (0, _typeHelpers.isObject)(eventsSchema) && !isMap && !isRecord;

  (0, _utils.invariant)(isMap || isPlainObject && !isMap && !isRecord, 'event-tracking-tools: param eventsSchema must be a Map of event records or plain object. Got "%s"', eventsSchema);

  if (isMap) {
    return eventsSchema;
  }
  return (0, _Immutable.Map)(eventsSchema);
}

function enforceAndConvertToRecord(maybeRecord, AcceptedRecord, recordList) {
  var isMap = _Immutable.Map.isMap(maybeRecord);
  var isRecord = maybeRecord instanceof _Immutable.Record;
  var isAcceptedRecord = (0, _getIsInstanceOfRecords2.default)(maybeRecord, recordList);
  var isPlainObject = (0, _typeHelpers.isObject)(maybeRecord) && !isMap && !isRecord;
  (0, _utils.invariant)(isPlainObject && !isRecord || isAcceptedRecord, 'event-tracking-tools: values of param eventsSchema must be plain objects or event records of type "%s". Got "%s"', AcceptedRecord.debugName, maybeRecord);

  if (isAcceptedRecord) {
    return maybeRecord;
  }
  return new AcceptedRecord(maybeRecord);
}

function convertSchemaToRecords(eventsSchema, AcceptedRecord, ForcedRecordClass) {
  eventsSchema = enforceAndConvertToMap(eventsSchema);

  var recordList = (0, _getRecordsAsList2.default)(AcceptedRecord);
  var conversionRecord = (0, _getConversionRecord2.default)(recordList, ForcedRecordClass);

  return eventsSchema.map(function (maybeRecord) {
    return enforceAndConvertToRecord(maybeRecord, conversionRecord, recordList);
  });
}

exports.default = convertSchemaToRecords;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/events/convertSchemaToRecords.js
// module id = 536
// module chunks = 0